module.exports = __webpack_public_path__ + "static/demo-hiragana-5c95f3aceef88f87953027efa942a22b.png";